/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
import React, { useEffect } from 'react';
import {
  View,
  TouchableOpacity,
  Linking,
  BackHandler,
  StyleSheet,
  Dimensions,
  Image,
} from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import RenderHtml from 'react-native-render-html';
import Modal from '@components/modal/Modal';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import { hideForceUpdate } from '@/store/global';

const { width: screenWidth } = Dimensions.get('window');

const ForceUpdateModal = () => {
  const dispatch = useDispatch();
  const forceUpdate = useSelector((state) => state.global.forceUpdate);

  const show = forceUpdate.show;
  const data = forceUpdate.data;

  const isBlocking = data ? !data.show_cancel_button : true;

  useEffect(() => {
    if (!show || !isBlocking) {
      return;
    }

    const subscription = BackHandler.addEventListener(
      'hardwareBackPress',
      () => true,
    );
    return () => subscription.remove();
  }, [show, isBlocking]);

  if (!show || !data) {
    return null;
  }

  const handleUpdate = () => {
    const url = data.mobile_apps_link?.url || '';
    if (url) {
      Linking.openURL(url).catch(() => {});
    }
  };

  const handleDismiss = () => {
    dispatch(hideForceUpdate());
  };

  return (
    <Modal
      transparent={true}
      visible={show}
      animationType="fade"
      needTop={true}
      onClose={() => (isBlocking ? undefined : handleDismiss())}>
      <View style={styles.centeredView}>
        <View style={styles.container}>
          {!!data.image && (
            <Image
              source={{ uri: data.image }}
              style={styles.banner}
              resizeMode="cover"
            />
          )}

          <View style={styles.body}>
            {!!data.title && (
              <SociollaText type="bold" style={styles.title}>
                {data.title}
              </SociollaText>
            )}

            {!!(data.message || data.description) && (
              <RenderHtml
                contentWidth={screenWidth - 80}
                source={{ html: data.message || data.description }}
                baseStyle={styles.htmlBase}
              />
            )}

            {data.show_button !== false && (
              <TouchableOpacity
                activeOpacity={0.8}
                style={styles.primaryButton}
                onPress={handleUpdate}>
                <SociollaText type="bold" style={styles.primaryButtonText}>
                  {data.button_text || 'Update Now'}
                </SociollaText>
              </TouchableOpacity>
            )}

            {!isBlocking && (
              <TouchableOpacity
                activeOpacity={0.7}
                style={styles.cancelButton}
                onPress={handleDismiss}>
                <SociollaText type="medium" style={styles.cancelButtonText}>
                  {data.cancel_button_title || 'Later'}
                </SociollaText>
              </TouchableOpacity>
            )}
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 24,
  },
  container: {
    width: '100%',
    backgroundColor: Colors.white,
    borderRadius: 12,
    overflow: 'hidden',
  },
  banner: {
    width: '100%',
    height: 180,
  },
  body: {
    padding: 20,
    alignItems: 'center',
  },
  title: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 10,
    color: Colors.black1,
  },
  htmlBase: {
    fontSize: 13,
    textAlign: 'center',
    color: Colors.black1,
    marginBottom: 20,
  },
  primaryButton: {
    backgroundColor: Colors.blue0,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 24,
    width: '100%',
    alignItems: 'center',
    marginBottom: 10,
  },
  primaryButtonText: {
    color: Colors.white,
    fontSize: 14,
  },
  cancelButton: {
    paddingVertical: 8,
  },
  cancelButtonText: {
    fontSize: 13,
    color: Colors.grey1,
  },
});

export default ForceUpdateModal;
